var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.5c0 5.75-4.7 10.42-10.5 10.42S0 16.25 0 10.49C0 4.74 4.7.07 10.5.07S21 4.74 21 10.5zm-9.16-6.91c-.4 0-.74.14-1.02.42s-.42.61-.42 1.01.14.74.42 1.02c.29.28.62.42 1.02.42s.74-.14 1.02-.42.42-.62.42-1.02-.14-.73-.41-1.01a1.4 1.4 0 00-1.03-.42zm.6 4.49h-.58l-3.34.54L8.4 9h.35c.22 0 .39.05.51.16a.5.5 0 01.19.38 4 4 0 01-.2 1.02l-1.37 4.67c-.1.37-.16.67-.16.91 0 .37.12.67.37.9.26.24.6.36 1.02.36 1.12 0 2.17-.85 3.16-2.56l-.33-.2a5.98 5.98 0 01-1.07 1.3.51.51 0 01-.33.15c-.07 0-.13-.03-.19-.09a.29.29 0 01-.09-.2c0-.12.06-.38.17-.78l2.02-6.94z",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle--info-f4ef26d87eb82a8da0d7a06d17316853.svg";
export { SvgIconCircleInfo as Component };